/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prd: NonNullable<unknown>, chat: NonNullable<unknown> }} Settings_Sub_CreditsInputs */

const en_settings_sub_credits = /** @type {(inputs: Settings_Sub_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add-on credits: ${i?.prd} PRD · ${i?.chat} chat`)
};

const id_settings_sub_credits = /** @type {(inputs: Settings_Sub_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kredit add-on: ${i?.prd} PRD · ${i?.chat} chat`)
};

/**
* | output |
* | --- |
* | "Add-on credits: {prd} PRD · {chat} chat" |
*
* @param {Settings_Sub_CreditsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_credits = /** @type {((inputs: Settings_Sub_CreditsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_CreditsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_credits(inputs)
	return en_settings_sub_credits(inputs)
});